import { ItemName, Locale } from '@ps-smart-cp/ppfw-client';

const tabs = {
  // subsystem-common
  commonWork: ItemName.of([Locale.ja, '業務共通']),
  operationManagement: ItemName.of([Locale.ja, '運用管理']),
  mstManagement: ItemName.of([Locale.ja, 'マスタ管理']),

  // fa
  leaseAssetManagement: ItemName.of([Locale.ja, 'リース管理']),
};

const blockTitles = {
  // subsystem-common
  variousSettings: ItemName.of([Locale.ja, '各種設定']),

  // system-management
  automation: ItemName.of([Locale.ja, '自動化']),
  userMaintenance: ItemName.of([Locale.ja, 'ユーザメンテナンス']),
  securitySettings: ItemName.of([Locale.ja, 'セキュリティ']),
  sysWorkMstMaintenance: ItemName.of([Locale.ja, '業務マスタメンテナンス']),

  // fa
  balanceBroughtForward: ItemName.of([Locale.ja, '繰越']),
  reference: ItemName.of([Locale.ja, '照会']),
  form: ItemName.of([Locale.ja, '帳票']),
  cancelRegistration: ItemName.of([Locale.ja, '取消']),
  importFile: ItemName.of([Locale.ja, 'リース登録(取込)']),
  increDecreEntry: ItemName.of([Locale.ja, '増減登録']),
  increDecreEntryImport: ItemName.of([Locale.ja, '増減登録(取込)']),
  migrateBalance: ItemName.of([Locale.ja, '残高移行']),
  registration: ItemName.of([Locale.ja, 'リース登録']),
  workMstMaintenance: ItemName.of([Locale.ja, '業務マスタメンテナンス']),
  segmentMstMaintenance: ItemName.of([Locale.ja, 'セグメントマスタメンテナンス']),
  customMstMaintenance: ItemName.of([Locale.ja, 'カスタムマスタメンテナンス']),
  manageOperation: ItemName.of([Locale.ja, '運用管理']),
  customField: ItemName.of([Locale.ja, 'カスタムフィールド']),
};

const functions = {
  /**
   * system-management
   */
  // common-work
  apiKeyMst: ItemName.of([Locale.ja, 'APIキー']),
  ruleMst: ItemName.of([Locale.ja, 'ルール']),
  targetMst: ItemName.of([Locale.ja, 'ターゲット']),

  // operation-management
  loginUserMst: ItemName.of([Locale.ja, 'ログインユーザ']),
  roleMst: ItemName.of([Locale.ja, 'ロール']),
  policyMst: ItemName.of([Locale.ja, 'ポリシー']),
  companyInfo: ItemName.of([Locale.ja, '会社情報']),
  passwordPolicy: ItemName.of([Locale.ja, 'パスワードポリシー']),
  sso: ItemName.of([Locale.ja, 'SSO']),

  // mst-management
  knowledgeBaseMst: ItemName.of([Locale.ja, 'ナレッジベース']),

  /**
   * fa
   */
  // commonWork
  confirmSettlementStatus: ItemName.of([Locale.ja, '決算状況確認']),
  // leaseManagement
  increaseDecreaseSummary: ItemName.of([Locale.ja, '固定資産増減合計表']),
  fixedAssetLedgerIndividual: ItemName.of([Locale.ja, '固定資産台帳(1件別明細)']),
  impairmentLossEntry: ItemName.of([Locale.ja, '固定資産減損損失計上']),
  increDecreCancel: ItemName.of([Locale.ja, '固定資産増減取消']),
  impairmentLossEntryImport: ItemName.of([Locale.ja, '固定資産減損損失計上(取込)']),
  fixedAssetListInquiry: ItemName.of([Locale.ja, '固定資産一覧照会']),
  leaseLiabilityLedger: ItemName.of([Locale.ja, 'リース債務台帳']),
  laContractPaymentConfirmationForm: ItemName.of([Locale.ja, 'リース契約支払確認表']),
  leaseExpenseSummaryTable: ItemName.of([Locale.ja, 'リース費用集計表']),
  leaseLiabilityEstimateChange: ItemName.of([Locale.ja, 'リース見積変更']),
  leaseEstimateChangeImport: ItemName.of([Locale.ja, 'リース見積変更(取込)']),
  referenceLeaseLiabilityEstimateChangeList: ItemName.of([Locale.ja, 'リース見積変更一覧照会']),
  referenceContractList: ItemName.of([Locale.ja, '契約一覧照会']),
  referenceArticleList: ItemName.of([Locale.ja, '物件一覧照会']),
  contractLedgerIndividual: ItemName.of([Locale.ja, '契約台帳(1件別明細)']),
  articleLedgerIndividual: ItemName.of([Locale.ja, '物件台帳(1件別明細)']),
  startRegistration: ItemName.of([Locale.ja, 'リース開始登録']),
  laStartImport: ItemName.of([Locale.ja, 'リース開始登録(取込)']),
  laCancelBefMaturityImport: ItemName.of([Locale.ja, 'リース中途解約(取込)']),
  changeContractInformation: ItemName.of([Locale.ja, 'リース契約情報変更']),
  laContractInfoChangeImport: ItemName.of([Locale.ja, 'リース契約情報変更(取込)']),
  changeArticleInformation: ItemName.of([Locale.ja, 'リース物件情報変更']),
  laArticleInfoChangeImport: ItemName.of([Locale.ja, 'リース物件情報変更(取込)']),
  reLeaseAndContractExpiration: ItemName.of([Locale.ja, '再リース及び契約満了']),
  reLeaseAndContractExpirationImport: ItemName.of([Locale.ja, '再リース及び契約満了(取込)']),
  laMigrateBalanceImport: ItemName.of([Locale.ja, 'リース残高移行(取込)']),
  laMigrateBalanceDelete: ItemName.of([Locale.ja, 'リース残高移行削除']),
  cancellationBeforeMaturity: ItemName.of([Locale.ja, 'リース中途解約']),
  cancelRegistration: ItemName.of([Locale.ja, 'リース登録取消']),
  faCustomFieldChange: ItemName.of([Locale.ja, '固定資産カスタムフィールド変更']),
  faCustomFieldChangeImport: ItemName.of([Locale.ja, '固定資産カスタムフィールド変更(取込)']),
  // mstManagement
  leaseCompanyMst: ItemName.of([Locale.ja, 'リース会社']),
  categoryMst: ItemName.of([Locale.ja, '種類']),
  subCategoryMst: ItemName.of([Locale.ja, '分類']),
  businessConnectionMst: ItemName.of([Locale.ja, '取引先']),
  locationMst: ItemName.of([Locale.ja, '設置場所']),
  nameMst: ItemName.of([Locale.ja, '名称']),
  // operationManagement
  jobMonitorCompany: ItemName.of([Locale.ja, 'ジョブ監視(会社)']),
  articleManagementSettings: ItemName.of([Locale.ja, '物件管理']),
  operationControl: ItemName.of([Locale.ja, '運用制御']),
  accountingPolicy: ItemName.of([Locale.ja, '会計方針']),
  mst: ItemName.of([Locale.ja, 'マスタ']),
  customField: ItemName.of([Locale.ja, 'カスタムフィールド']),
  interestRate: ItemName.of([Locale.ja, '利子率']),
};

export { blockTitles, functions, tabs };
